import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import FeeReceipt from "./FeeReceipt";
import FeeReceiptMultiple from "./FeeReceiptMultiple";
import DailyFeeReport from "./DailyFeeReport";
import DailyFeeReportPerFeeHead from "./DailyFeeReportPerFeeHead";
import DfcReport from "./DfcReport";
function Fee() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState("home");
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
  }, []);

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const handleNavigate = (path) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      navigate("/authentication/sign-in");
    } else {
      setActiveView(path);
    }
  };

  const handleBack = () => {
    setActiveView("home");
  };

  const renderContent = () => {
    switch (activeView) {
      case "feereceipt":
        return (
          <>
            <FeeReceipt />
          </>
        );
      case "feereceipt-multiple":
        return (
          <>
            <FeeReceiptMultiple />
          </>
        );
      case "dailyfeereport":
        return (
          <>
            <DailyFeeReport />
          </>
        );
      case "feeheadreport":
        return (
          <>
            <DailyFeeReportPerFeeHead />
          </>
        );
      case "dfcreport":
        return (
          <>
            <DfcReport />
          </>
        );
      default:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>house</Icon>}
                onClick={() => handleNavigate("feereceipt")}
              >
                FEE RECEIPT
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>receipt_long</Icon>}
                onClick={() => handleNavigate("feereceipt-multiple")}
              >
                MULTIPLE FEE RECEIPTs
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>house</Icon>}
                onClick={() => handleNavigate("dailyfeereport")}
              >
                DAILY FEE REPORT
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>house</Icon>}
                onClick={() => handleNavigate("feeheadreport")}
              >
                FEE HEAD WISE REPORT
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>payments</Icon>}
                onClick={() => handleNavigate("dfcreport")}
              >
                DFC - DAILY FEE COLLECTION
              </MDButton>
            </Grid>
          </Grid>
        );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-1}
                  py={1}
                  px={2}
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h6" color="white">
                    COLLECT FEES
                  </MDTypography>
                  {activeView !== "home" && (
                    <MDButton
                      variant="contained"
                      coloredShadow="info"
                      onClick={handleBack}
                      startIcon={<Icon>arrow_back</Icon>}
                      sx={{ mb: 0 }}
                    >
                      Back to Fees
                    </MDButton>
                  )}
                </MDBox>

                <MDBox p={1}>{renderContent()}</MDBox>
              </Card>
            </Grid>
          </Grid>
        )}
      </MDBox>
      <MDBox display="flex" flexDirection="column" minHeight="50vh"></MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Fee;
